import TopNav from './components/TopNav';
import Hero from './components/Hero';
import YearNumbers from './components/YearNumbers';
import KingBoard from './components/KingBoard';
import CategoryList from './components/CategoryList';
import MonthRecall from './components/MonthRecall';
import HotTalk from './components/HotTalk';
import FaqSection from './components/FaqSection';
import Principles from './components/Principles';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-sans text-foreground-950">
      <TopNav />
      <main>
        <Hero />
        <YearNumbers />
        <KingBoard />
        <CategoryList />
        <MonthRecall />
        <HotTalk />
        <FaqSection />
        <Principles />
      </main>
      <SiteFooter />
    </div>
  );
}